import { render, staticRenderFns } from "./notAuthorized.vue?vue&type=template&id=bc3ecbe2"
import script from "./notAuthorized.vue?vue&type=script&lang=js"
export * from "./notAuthorized.vue?vue&type=script&lang=js"
import style0 from "./notAuthorized.vue?vue&type=style&index=0&id=bc3ecbe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports